import React from 'react';

const cardShadow = { boxShadow: '10px 13px 0px #898db740' };

const QuotationSection: React.FC = () => {
  return (
    <section className="py-12 lg:py-16 bg-gray-100">
      <div className="max-w-content mx-auto px-6">
        <h2 className="font-exo font-bold text-2xl lg:text-[38px] tracking-[0.72px] leading-normal text-center mt-4 lg:mt-8">
          <span className="text-royal-blue">3 Day</span>
          <span className="text-ebony-clay"> Professional Quotation</span>
        </h2>

        <p className="font-proxima text-black text-sm lg:text-base tracking-[0.8px] leading-normal text-center mb-10">
          Our expert team delivers comprehensive quotations in just 3 business days
        </p>

        {/* Cards row */}
        <div className="flex flex-col md:flex-row gap-6 lg:gap-8 justify-center items-stretch">
          {/* Card 1: Senior Developers */}
          <div className="relative w-full md:w-[387px] flex-shrink-0 border-2 border-wistful rounded overflow-hidden" style={cardShadow}>
            <div className="bg-white border border-black p-6 lg:p-8 pb-24 lg:pb-28 flex flex-col h-full relative">
              <img
                className="w-full aspect-[323/401] object-cover"
                src={require('../assets/img/quotation/photo-developers.png')}
                alt="Senior Developers"
              />
              <h3 className="relative z-10 font-proxima-bold font-bold text-black text-lg lg:text-xl tracking-[1px] leading-normal mt-4 lg:mt-6">
                Senior Developers
              </h3>
              <p className="relative z-10 font-proxima text-black text-sm lg:text-base tracking-[0.8px] leading-normal mt-2 flex-grow">
                Technical architects review your requirements for feasibility and best practices&nbsp;&nbsp;Business Analysts
              </p>
              {/* Circles + icon in bottom-right corner */}
              <div className="absolute -right-20 -bottom-20 w-[200px] lg:w-[253px] h-[200px] lg:h-[253px]">
                <div className="absolute inset-0 opacity-[0.18] pointer-events-none">
                  <div className="absolute inset-0 rounded-full bg-royal-blue opacity-[0.15]" />
                  <div className="absolute left-4 lg:left-6 top-4 lg:top-6 w-[160px] lg:w-[206px] h-[160px] lg:h-[206px] rounded-full bg-royal-blue opacity-50" />
                  <div className="absolute left-8 lg:left-12 top-8 lg:top-12 w-[120px] lg:w-[157px] h-[120px] lg:h-[157px] rounded-full bg-royal-blue" />
                </div>
              </div>
              <img className="absolute right-7 bottom-7 lg:right-10 lg:bottom-10 w-7 h-7 lg:w-10 lg:h-10 object-contain z-0 pointer-events-none" src={require('../assets/img/quotation/icon-developers.svg').default} alt="" />
            </div>
          </div>

          {/* Card 2: Business Analysts */}
          <div className="relative w-full md:w-[387px] flex-shrink-0 border-2 border-wistful rounded overflow-hidden md:mt-8" style={cardShadow}>
            <div className="bg-white border border-black p-6 lg:p-8 pb-24 lg:pb-28 flex flex-col h-full relative">
              <img
                className="w-full aspect-[323/401] object-cover"
                src={require('../assets/img/quotation/photo-analysts.png')}
                alt="Business Analysts"
              />
              <h3 className="relative z-10 font-proxima-bold font-bold text-black text-lg lg:text-xl tracking-[1px] leading-normal mt-4 lg:mt-6">
                Business Analysts
              </h3>
              <p className="relative z-10 font-proxima text-black text-sm lg:text-base tracking-[0.8px] leading-normal mt-2 flex-grow">
                Ensure complete understanding of your business goals and ROI expectations <br />Quality Assurance
              </p>
              {/* Circles + icon in bottom-right corner */}
              <div className="absolute -right-20 -bottom-20 w-[200px] lg:w-[253px] h-[200px] lg:h-[253px]">
                <div className="absolute inset-0 opacity-[0.18] pointer-events-none">
                  <div className="absolute inset-0 rounded-full bg-royal-blue opacity-[0.15]" />
                  <div className="absolute left-4 lg:left-6 top-4 lg:top-6 w-[160px] lg:w-[206px] h-[160px] lg:h-[206px] rounded-full bg-royal-blue opacity-50" />
                  <div className="absolute left-8 lg:left-12 top-8 lg:top-12 w-[120px] lg:w-[157px] h-[120px] lg:h-[157px] rounded-full bg-royal-blue" />
                </div>
              </div>
              <img className="absolute right-7 bottom-7 lg:right-10 lg:bottom-10 w-7 h-7 lg:w-10 lg:h-10 object-contain z-0 pointer-events-none" src={require('../assets/img/quotation/icon-analysts.svg').default} alt="" />
            </div>
          </div>

          {/* Card 3: Quality Assurance */}
          <div className="relative w-full md:w-[387px] flex-shrink-0 border-2 border-wistful rounded overflow-hidden" style={cardShadow}>
            <div className="bg-white border border-black p-6 lg:p-8 pb-24 lg:pb-28 flex flex-col h-full relative">
              <img
                className="w-full aspect-[323/401] object-cover"
                src={require('../assets/img/quotation/photo-qa.png')}
                alt="Quality Assurance"
              />
              <h3 className="relative z-10 font-proxima-bold font-bold text-black text-lg lg:text-xl tracking-[1px] leading-normal mt-4 lg:mt-6">
                Quality Assurance
              </h3>
              <p className="relative z-10 font-proxima text-black text-sm lg:text-base tracking-[0.8px] leading-normal mt-2 flex-grow">
                Technical architects review your requirements for feasibility and best practices&nbsp;&nbsp;Business Analysts
              </p>
              {/* Circles + icon in bottom-right corner */}
              <div className="absolute -right-20 -bottom-20 w-[200px] lg:w-[253px] h-[200px] lg:h-[253px]">
                <div className="absolute inset-0 opacity-[0.18] pointer-events-none">
                  <div className="absolute inset-0 rounded-full bg-royal-blue opacity-[0.15]" />
                  <div className="absolute left-4 lg:left-6 top-4 lg:top-6 w-[160px] lg:w-[206px] h-[160px] lg:h-[206px] rounded-full bg-royal-blue opacity-50" />
                  <div className="absolute left-8 lg:left-12 top-8 lg:top-12 w-[120px] lg:w-[157px] h-[120px] lg:h-[157px] rounded-full bg-royal-blue" />
                </div>
              </div>
              <img className="absolute right-7 bottom-7 lg:right-10 lg:bottom-10 w-7 h-7 lg:w-10 lg:h-10 object-contain z-0 pointer-events-none" src={require('../assets/img/quotation/icon-qa.svg').default} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuotationSection;
